/// <reference path="../../types.d.ts" />

import { connect } from 'react-redux';
import AutomationDashboard, {
  AutomationDashboardViewProps
} from './automation-dashboard';
import {
  initializeDashboard,
  selectHealthSystemAndFetch,
  selectServiceLineAndFetch,
  selectTenantAndFetch,
  selectDateSelectionAndFetch
} from './actions';
import { selectAutomationDashboard } from './selectors';
import { DateRangeSelection } from '../../components/automation-trend-chart';

type StateProps = Pick<
  AutomationDashboardViewProps,
  | 'healthSystem'
  | 'serviceLine'
  | 'tenant'
  | 'dateRangePresetId'
  | 'dateRange'
  | 'loadState'
  | 'data'
  | 'error'
  | 'filterOptions'
>;
type DispatchProps = Pick<
  AutomationDashboardViewProps,
  | 'onMount'
  | 'onHealthSystemChange'
  | 'onServiceLineChange'
  | 'onTenantChange'
  | 'onDateRangeChange'
>;

const mapStateToProps = (state: CMx.ApplicationState): StateProps => {
  const slice = selectAutomationDashboard(state);
  return {
    healthSystem: slice.filters.health_system_code,
    serviceLine: slice.filters.service_line,
    tenant: slice.filters.tenant_code,
    dateRangePresetId: slice.dateRangePresetId,
    dateRange: slice.dateRange,
    loadState: slice.loadState,
    data: slice.data,
    error: slice.error,
    filterOptions: slice.filterOptions
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  onMount: () => dispatch(initializeDashboard()),
  onHealthSystemChange: (code: string) =>
    dispatch(selectHealthSystemAndFetch(code)),
  onServiceLineChange: (code: string) =>
    dispatch(selectServiceLineAndFetch(code)),
  onTenantChange: (code: string) => dispatch(selectTenantAndFetch(code)),
  onDateRangeChange: (selection: DateRangeSelection) =>
    dispatch(selectDateSelectionAndFetch(selection))
});

export default connect(mapStateToProps, mapDispatchToProps)(AutomationDashboard);
